module.exports = __webpack_public_path__ + "static/media/logo-white.0ee8cb77.svg";